<template>
  <div id="app">
    <router-view />
    <!-- Mobile Store Redirect Popup -->
<!--    <div v-if="showPopup" class="popup-overlay">-->
<!--      <div class="popup-content">-->
<!--        <p>We have a mobile app! Download it from the store:</p>-->
<!--        <div class="button-container">-->
<!--          <button @click="redirectToStore">-->
<!--            <img v-if="isAndroid" src="/assets/google-play-icon.png" alt="Google Play Store" />-->
<!--            <img v-if="isIOS" src="/assets/app-store-icon.png" alt="App Store" />-->
<!--            Download Now-->
<!--          </button>-->
<!--        </div>-->
<!--&lt;!&ndash;        <button @click="closePopup" class="close-btn">X</button>&ndash;&gt;-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>


<script>
import "@/assets/site/css/govava.min.css";
import "@/assets/site/css/styles-l.min.css";
import "@/assets/site/css/config_default.css";
import "@/assets/site/css/custom.css";

export default {
  name: 'App',
  data() {
    return {
      showPopup: false, // to toggle the popup visibility
      isMobile: false, // to store if the user is on a mobile device
      isAndroid: false, // to detect if Android device
      isIOS: false, // to detect if iOS device
    };
  },
  mounted() {
    this.detectMobileDevice();
  },
  methods: {
    detectMobileDevice() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      this.isMobile = /iphone|ipod|android|windows phone|blackberry|iemobile|opera mini/i.test(userAgent);

      if (this.isMobile) {
        this.isAndroid = /android/i.test(userAgent); // Check if Android device
        this.isIOS = /iphone|ipod/i.test(userAgent);  // Check if iOS device
        this.showPopup = true; // Show the popup if the user is on mobile
      }
    },
    redirectToStore() {
      if (this.isAndroid) {
        // Redirect to Google Play Store for Android
        window.location.href = 'https://play.google.com/store/apps/details?id=com.app.govavaai'; // Replace with your app's package name
      } else if (this.isIOS) {
        // Redirect to App Store for iOS
        window.location.href = 'https://apps.apple.com/us/app/govava/id6739616822';
      }
    },
    closePopup() {
      this.showPopup = false; // Close the popup if the user clicks the "X"
    },
  },
};
</script>

<style scoped>
/* Popup Overlay */
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Popup Content */
.popup-content {
  background: white;
  padding: 20px;
  text-align: center;
  border-radius: 10px;
  width: 80%;
  max-width: 400px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Button Container */
.button-container {
  margin-top: 20px;
}

button {
  background-color: #4CAF50;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
  border: none;
  border-radius: 5px;
}

/* Close Button */
.close-btn {
  background: red;
  color: white;
  font-size: 20px;
  padding: 10px;
  border-radius: 50%;
  border: none;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}
</style>